"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrUpdateUserConsentsFailure = exports.fetchOrUpdateUserConsentsSuccess = exports.fetchOrUpdateUserConsentsRequest = exports.updateEmailFailure = exports.updateEmailSuccess = exports.updateEmail = exports.setNewEmail = exports.setCustomer = exports.fetchCustomersFailed = exports.fetchCustomersSuccess = exports.fetchCustomers = exports.updateUserCompanyFailure = exports.updateUserCompanySuccess = exports.updateUserCompany = exports.removeUserFailure = exports.removeUserSuccess = exports.removeUserRequest = exports.changePasswordFailure = exports.changePasswordSuccess = exports.changePasswordRequest = exports.resetPasswordFailure = exports.resetPasswordSuccess = exports.resetPasswordRequest = exports.resendAuthenticationCodeFailure = exports.resendAuthenticationCodeSuccess = exports.resendAuthenticationCodeRequest = exports.updateMemberInfoValidation = exports.updateMemberInfoFailure = exports.updateMemberInfoSuccess = exports.updateMemberInfoRequest = exports.updatePasswordValue = exports.updateValue = exports.changeTab = exports.closeUserSettingsModal = exports.openUserSettingsModal = void 0;
const ActionTypes = require("../../actionTypes/user/userSettings");
const openUserSettingsModal = (user, mode, onCloseActions = []) => ({
    type: ActionTypes.OPEN_USER_SETTINGS_MODAL,
    payload: {
        user,
        mode,
        onCloseActions
    }
});
exports.openUserSettingsModal = openUserSettingsModal;
const closeUserSettingsModal = (onCloseActions) => ({
    type: ActionTypes.CLOSE_USER_SETTINGS_MODAL,
    payload: onCloseActions
});
exports.closeUserSettingsModal = closeUserSettingsModal;
const changeTab = (index) => ({
    type: ActionTypes.CHANGE_TAB,
    payload: index
});
exports.changeTab = changeTab;
const updateValue = (field, value) => ({
    type: ActionTypes.UPDATE_VALUE,
    payload: {
        field,
        value
    }
});
exports.updateValue = updateValue;
const updatePasswordValue = (field, value) => ({
    type: ActionTypes.UPDATE_PASSWORD_VALUE,
    payload: {
        field,
        value
    }
});
exports.updatePasswordValue = updatePasswordValue;
function updateMemberInfoRequest() {
    return {
        type: ActionTypes.UPDATE_MEMBER_INFO_REQUEST
    };
}
exports.updateMemberInfoRequest = updateMemberInfoRequest;
function updateMemberInfoSuccess(user) {
    return {
        type: ActionTypes.UPDATE_MEMBER_INFO_SUCCESS,
        payload: user
    };
}
exports.updateMemberInfoSuccess = updateMemberInfoSuccess;
function updateMemberInfoFailure(payload) {
    return {
        type: ActionTypes.UPDATE_MEMBER_INFO_FAILURE,
        payload
    };
}
exports.updateMemberInfoFailure = updateMemberInfoFailure;
function updateMemberInfoValidation(payload) {
    return {
        type: ActionTypes.UPDATE_MEMBER_INFO_VALIDATION,
        payload
    };
}
exports.updateMemberInfoValidation = updateMemberInfoValidation;
function resendAuthenticationCodeRequest(id, email) {
    return {
        type: ActionTypes.RESEND_AUTHENTICATION_CODE_REQUEST,
        payload: {
            id,
            email
        }
    };
}
exports.resendAuthenticationCodeRequest = resendAuthenticationCodeRequest;
function resendAuthenticationCodeSuccess() {
    return {
        type: ActionTypes.RESEND_AUTHENTICATION_CODE_SUCCESS
    };
}
exports.resendAuthenticationCodeSuccess = resendAuthenticationCodeSuccess;
function resendAuthenticationCodeFailure(payload) {
    return {
        type: ActionTypes.RESEND_AUTHENTICATION_CODE_FAILURE,
        payload
    };
}
exports.resendAuthenticationCodeFailure = resendAuthenticationCodeFailure;
// Reset password
function resetPasswordRequest(id, email, language) {
    return {
        type: ActionTypes.RESET_PASSWORD_REQUEST,
        payload: {
            id,
            email,
            language
        }
    };
}
exports.resetPasswordRequest = resetPasswordRequest;
function resetPasswordSuccess() {
    return {
        type: ActionTypes.RESET_PASSWORD_SUCCESS
    };
}
exports.resetPasswordSuccess = resetPasswordSuccess;
function resetPasswordFailure(payload) {
    return {
        type: ActionTypes.RESET_PASSWORD_FAILURE,
        payload
    };
}
exports.resetPasswordFailure = resetPasswordFailure;
// change password
function changePasswordRequest(oldPassword, newPassword) {
    return {
        type: ActionTypes.CHANGE_PASSWORD_REQUEST,
        payload: {
            oldPassword,
            newPassword
        }
    };
}
exports.changePasswordRequest = changePasswordRequest;
function changePasswordSuccess() {
    return {
        type: ActionTypes.CHANGE_PASSWORD_SUCCESS
    };
}
exports.changePasswordSuccess = changePasswordSuccess;
function changePasswordFailure(payload) {
    return {
        type: ActionTypes.CHANGE_PASSWORD_FAILURE,
        payload
    };
}
exports.changePasswordFailure = changePasswordFailure;
// remove user
function removeUserRequest(uuid) {
    return {
        type: ActionTypes.REMOVE_USER_REQUEST,
        payload: uuid
    };
}
exports.removeUserRequest = removeUserRequest;
function removeUserSuccess() {
    return {
        type: ActionTypes.REMOVE_USER_SUCCESS
    };
}
exports.removeUserSuccess = removeUserSuccess;
function removeUserFailure(payload) {
    return {
        type: ActionTypes.REMOVE_USER_FAILURE,
        payload
    };
}
exports.removeUserFailure = removeUserFailure;
function updateUserCompany(user, company) {
    return {
        type: ActionTypes.UPDATE_USER_COMPANY,
        payload: {
            user: user,
            company: company
        }
    };
}
exports.updateUserCompany = updateUserCompany;
function updateUserCompanySuccess() {
    return {
        type: ActionTypes.UPDATE_USER_COMPANY_SUCCESS
    };
}
exports.updateUserCompanySuccess = updateUserCompanySuccess;
function updateUserCompanyFailure(payload) {
    return {
        type: ActionTypes.UPDATE_USER_COMPANY_FAILURE,
        payload
    };
}
exports.updateUserCompanyFailure = updateUserCompanyFailure;
const fetchCustomers = (name) => ({
    type: ActionTypes.FETCH_CUSTOMERS,
    payload: {
        name
    }
});
exports.fetchCustomers = fetchCustomers;
const fetchCustomersSuccess = (customers) => ({
    type: ActionTypes.FETCH_CUSTOMERS_SUCCESS,
    payload: {
        customers
    }
});
exports.fetchCustomersSuccess = fetchCustomersSuccess;
function fetchCustomersFailed(error) {
    return {
        type: ActionTypes.FETCH_CUSTOMERS_FAILED,
        payload: error
    };
}
exports.fetchCustomersFailed = fetchCustomersFailed;
const setCustomer = (customer) => {
    return {
        type: ActionTypes.SET_CUSTOMER,
        payload: {
            customer: customer
        }
    };
};
exports.setCustomer = setCustomer;
const setNewEmail = (newEmail) => {
    return {
        type: ActionTypes.SET_NEW_EMAIL,
        payload: {
            newEmail: newEmail
        }
    };
};
exports.setNewEmail = setNewEmail;
function updateEmail() {
    return {
        type: ActionTypes.UPDATE_EMAIL
    };
}
exports.updateEmail = updateEmail;
function updateEmailSuccess() {
    return {
        type: ActionTypes.UPDATE_EMAIL_SUCCESS
    };
}
exports.updateEmailSuccess = updateEmailSuccess;
function updateEmailFailure(error) {
    return {
        type: ActionTypes.UPDATE_EMAIL_FAILURE,
        payload: error
    };
}
exports.updateEmailFailure = updateEmailFailure;
const fetchOrUpdateUserConsentsRequest = (userId, consents) => ({
    type: ActionTypes.FETCH_OR_UPDATE_USER_CONSENTS_REQUEST,
    payload: { userId, consents }
});
exports.fetchOrUpdateUserConsentsRequest = fetchOrUpdateUserConsentsRequest;
const fetchOrUpdateUserConsentsSuccess = (reqType, consents) => ({
    type: ActionTypes.FETCH_OR_UPDATE_USER_CONSENTS_SUCCESS,
    payload: { reqType, consents }
});
exports.fetchOrUpdateUserConsentsSuccess = fetchOrUpdateUserConsentsSuccess;
const fetchOrUpdateUserConsentsFailure = (reqType, error) => ({
    type: ActionTypes.FETCH_OR_UPDATE_USER_CONSENTS_FAILURE,
    payload: { reqType, error }
});
exports.fetchOrUpdateUserConsentsFailure = fetchOrUpdateUserConsentsFailure;
//# sourceMappingURL=userSettings.js.map